"use client";

import { isAppleSignInAvailable, startAppleSignIn } from "@/lib/social-auth";
import { reportSocialAuthFailure } from "@/lib/report-social-auth-failure";
import { useCallback, useState } from "react";

export const useAppleSignIn = (locale: string) => {
  const [isPending, setIsPending] = useState(false);
  const isAvailable = isAppleSignInAvailable();

  const start = useCallback(async () => {
    if (!isAvailable || isPending) return;
    setIsPending(true);
    try {
      await startAppleSignIn({ locale });
    } catch (error) {
      setIsPending(false);
      reportSocialAuthFailure("start", error, "apple");
      throw error;
    }
  }, [isAvailable, isPending, locale]);

  return { isAvailable, isPending, start };
};
